import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: true
})
export class FilterPipe implements PipeTransform {

  transform(value: any, searchTearm: any): any {
    if(value != undefined){
      return value.filter(function(search:any){

        return (
          search.displayName.toLowerCase().includes(searchTearm.toLowerCase())||
          search.displayName.toLowerCase().includes(searchTearm.toLowerCase())

      );

       // return search.displayName.toLowerCase().indexOf(searchTearm) > -1
      });
    }
  }
}
